<template>
  <!-- <figure class="highcharts-figure"> -->
     <div :id="id"></div>
     <span v-if="theme == 'light' || theme =='medium' || theme=='dark' "></span>

    <!-- <img
    src="@/assets/images/pie-bg.svg"
    alt="#"
    class="pie-bg"
    v-if="theme == 'light' || theme =='medium'"
  />
  <img
    src="@/assets/images/pie-bg-dark.svg"
    alt="#"
    class="pie-bg"
    v-if="theme == 'dark'"
  /> -->
  <!-- </figure> -->
</template>

<script>
import store from "@/store";

import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
highchartsMore(Highcharts);
solidGauge(Highcharts);

export default {
  name: "PieV3",
  props: ["id","chartData","chartColors"],
  data() {
    return {
      seriesData: []
    }
  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
  },
  updated() {
   this.seriesData = [];
   this.renderChart();
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart: function() {
      // console.log(this.chartData);
    for(let i = this.chartData.length - 1; i >=0; i--) {
      const feed = {
              name: this.chartData[i].key,
              y: this.chartData[i].value,
              color: {
                // radialGradient: { cx: 0.55, cy: 0.55, r: 0.9 },
                 radialGradient: { cx: 0.5, cy: 0.5, r: 0.7 },
                stops: [
                  [0, this.chartColors[i].stop1], /// start
                  [1, this.chartColors[i].stop2], // end
                ],
              },
              
              dataLabels: {
                z: 6,
                connectorColor: "#90B2B9",
                distance: 20,
                useHTML: true,
                format:
                this.theme == 'light' || this.theme =='medium' ? 
                `<div class='cust-chart-datalabel' style='white-space:normal;position:relative;color:#527A7A !important'>${this.chartData[i].key} <span class="${(i == this.chartData.length -1 ) ? 'cust-label': 'cust-label left' }" style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.chartData[i].value}</span></div>` :
                `<div class='cust-chart-datalabel' style='white-space:normal;position:relative;color:#1B6371 !important'>${this.chartData[i].key} <span class="${(i == this.chartData.length - 1 ) ? 'cust-label': 'cust-label left' }" style='background-color:#103C64;border:0px solid #1B6371;color:#fff'>${this.chartData[i].value}</span></div>`

              }
            };
            this.seriesData.push(feed);
    }
    // Build the chart
    Highcharts.chart(this.id, {
      chart: {
        backgroundColor: "transparent",
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
        margin: [0, 0, 0, 0],
        width: 400,
        height: 200,
        style: {
          overflow: "visible"
        }
        
        // height: '500px'
      },
      colorAxis: {},
      title: null,
      tooltip: {
        enabled: true,
        pointFormat: "<b>{point.percentage:.1f}%</b>:{series.name}",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          borderWidth: 0,
          borderColor: this.theme == 'light' || this.theme=='medium' ? "#fff" : '#071D1D',
          // center: ["50%", "50%"],
          allowPointSelect: true,
          cursor: "pointer",
          size: "80%",
          
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>",
            connectorColor: "#2BC4BB",
            color: "#4a7780",
            distance: 50,
          },
        },
      },
      series: [
        {
          showInLegend: false,
          name: "كراسات الطرح",
          data: this.seriesData,
          animation: {
            duration: 1500
          }
        },
      ],
    });
     document.querySelectorAll('.highcharts-credits').forEach(item => item.style.display = 'none');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
body.theme-light {
   .pie-bg {
    position: absolute;
    top: 164px;
    left: 158px;
    z-index: 0;
  }
  #pie1,
  #pie2,
  #pie3 {
    width: 390px !important;
    height: 190px !important;
    overflow: visible !important;
    margin-top: 30px;
    margin-left: 20px;

    .highcharts-container  {
      overflow: visible !important
    }

    .highcharts-figure,
    .highcharts-data-table table {
      min-width: 320px;
      max-width: 660px;
    }

    .highcharts-data-table table {
      font-family: Verdana, sans-serif;
      border-collapse: collapse;
      border: 1px solid #ebebeb;
      margin: 10px auto;
      text-align: center;
      width: 100%;
      max-width: 500px;
    }

    .highcharts-data-table caption {
      padding: 1em 0;
      font-size: 1.2em;
      color: #555;
    }

    .highcharts-data-table th {
      font-weight: 600;
      padding: 0.5em;
    }

    .highcharts-data-table td,
    .highcharts-data-table th,
    .highcharts-data-table caption {
      padding: 0.5em;
    }

    .highcharts-data-table thead tr,
    .highcharts-data-table tr:nth-child(even) {
      background: #f8f8f8;
    }

    .highcharts-data-table tr:hover {
      background: #f1f7ff;
    }
    .highcharts-data-label {
      text-align: right;
      @include apply-font($almarai, 700, 12px, #4a7780);
      text {
        color: #4a7780 !important;
      }
    }
    .highcharts-text-outline {
      stroke: transparent !important;
      stroke-width: 0px !important;
    }
    .cust-chart-datalabel {
      @include apply-font($almarai, 700, 12px, #92ADB2);
     .cust-label {
      width:23px;
      height:23px;
      border-radius:20px;
      background-color:transparent;
      border: 1px solid #48B0C4;
      position:absolute;
      margin-left:10px;
      top:-5px;
      display:inline-flex;
      justify-content:center;
      align-items:center;
    }
    .cust-label.left {
      left:-40px;
    }
  }
  }

}
body.theme-medium {
   .pie-bg {
    position: absolute;
    top: 164px;
    left: 158px;
    z-index: 0;
  }
  #pie1,
  #pie2,
  #pie3 {
    width: 390px !important;
    height: 190px !important;
    overflow: visible !important;
    margin-top: 30px;
    margin-left: 20px;

    .highcharts-container  {
      overflow: visible !important
    }
    .highcharts-figure,
    .highcharts-data-table table {
      min-width: 320px;
      max-width: 660px;
    }

    .highcharts-data-table table {
      font-family: Verdana, sans-serif;
      border-collapse: collapse;
      border: 1px solid #ebebeb;
      margin: 10px auto;
      text-align: center;
      width: 100%;
      max-width: 500px;
    }

    .highcharts-data-table caption {
      padding: 1em 0;
      font-size: 1.2em;
      color: #555;
    }

    .highcharts-data-table th {
      font-weight: 600;
      padding: 0.5em;
    }

    .highcharts-data-table td,
    .highcharts-data-table th,
    .highcharts-data-table caption {
      padding: 0.5em;
    }

    .highcharts-data-table thead tr,
    .highcharts-data-table tr:nth-child(even) {
      background: #f8f8f8;
    }

    .highcharts-data-table tr:hover {
      background: #f1f7ff;
    }
    .highcharts-data-label {
      text-align: right;
      @include apply-font($almarai, 700, 12px, #4a7780);
      text {
        color: #4a7780 !important;
      }
    }
    .highcharts-text-outline {
      stroke: transparent !important;
      stroke-width: 0px !important;
    }
    .cust-chart-datalabel {
      @include apply-font($almarai, 700, 12px, #92ADB2);
     .cust-label {
      width:23px;
      height:23px;
      border-radius:20px;
      background-color:transparent;
      border: 1px solid #48B0C4;
      position:absolute;
      margin-left:10px;
      top:-5px;
      display:inline-flex;
      justify-content:center;
      align-items:center;
    }
    .cust-label.left {
      left:-40px;
    }
  }
  }

}
body.theme-dark {
  .pie-bg {
    position: absolute;
    top: 164px;
    left: 158px;
    z-index: 0;
  }
  #pie1,
  #pie2,
  #pie3 {
    width: 390px !important;
    height: 190px !important;
    overflow: visible !important;
    margin-top: 30px;
    margin-left: 20px;

    .highcharts-container  {
      overflow: visible !important
    }
    .highcharts-figure,
    .highcharts-data-table table {
      min-width: 320px;
      max-width: 660px;
    }

    .highcharts-data-table table {
      font-family: Verdana, sans-serif;
      border-collapse: collapse;
      border: 1px solid #ebebeb;
      margin: 10px auto;
      text-align: center;
      width: 100%;
      max-width: 500px;
    }

    .highcharts-data-table caption {
      padding: 1em 0;
      font-size: 1.2em;
      color: #555;
    }

    .highcharts-data-table th {
      font-weight: 600;
      padding: 0.5em;
    }

    .highcharts-data-table td,
    .highcharts-data-table th,
    .highcharts-data-table caption {
      padding: 0.5em;
    }

    .highcharts-data-table thead tr,
    .highcharts-data-table tr:nth-child(even) {
      background: #f8f8f8;
    }

    .highcharts-data-table tr:hover {
      background: #f1f7ff;
    }
    .highcharts-data-label {
      text-align: right;
      @include apply-font($almarai, 700, 12px, #4a7780);
      text {
        color: #4a7780 !important;
      }
    }
    .highcharts-text-outline {
      stroke: transparent !important;
      stroke-width: 0px !important;
    }

    .cust-chart-datalabel {
      @include apply-font($almarai, 700, 12px, #92ADB2);
     .cust-label {
      width:23px;
      height:23px;
      border-radius:20px;
      background-color:#3FF4EA;
      position:absolute;
      margin-left:10px;
      top:-5px;
      display:inline-flex;
      justify-content:center;
      align-items:center;
    }
    .cust-label.left {
      left:-40px;
    }
  }
    
  }
}
</style>